var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDouglasAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 12,
    fill: "#3CBEAF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.4475 26.5583C38.0591 25.5312 39.9325 24.9902 41.8435 25.0001C47.6434 25.0001 52 29.4149 52 35.2725C52 41.1302 47.6429 45.5451 41.8429 45.5451C35.986 45.5451 31.7443 41.2167 31.7443 35.2725C31.7367 33.3478 32.2664 31.4591 33.2737 29.819C33.8018 30.2018 34.2523 30.6816 34.601 31.2328C33.9979 32.4933 33.6919 33.8753 33.7066 35.2725C33.7066 40.1492 37.1116 43.6407 41.8438 43.6407C46.6337 43.6407 50.0388 40.1492 50.0388 35.2725C50.0388 30.3672 46.6337 26.8468 41.8438 26.8468C40.4234 26.8279 39.022 27.1758 37.7753 27.8568C37.3841 27.3744 36.9386 26.9387 36.4475 26.5583ZM32.7541 42.5152C32.2183 42.7528 31.6566 42.9271 31.0805 43.0347C30.0439 43.2299 28.9898 43.3171 27.9353 43.2948H21.9621V27.222H27.9353C28.9898 27.1997 30.0439 27.2869 31.0805 27.4822C34.8605 28.2901 36.9381 31.0313 36.9381 35.273C36.9643 36.6622 36.6886 38.0405 36.1301 39.3128C36.4834 39.8766 36.9214 40.3826 37.4286 40.8133C38.3809 39.2551 38.9003 37.3506 38.9003 35.273C38.9003 30.1369 36.1878 26.7319 31.5709 25.722C30.4702 25.4938 29.3477 25.3873 28.2237 25.4046H20V45.1412H28.2237C29.3467 45.1674 30.4691 45.0706 31.5709 44.8526C32.4348 44.6682 33.2696 44.3674 34.0525 43.9582C33.5467 43.5483 33.1085 43.0614 32.7541 42.5152Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDouglasAppIcon);
export default __webpack_public_path__ + "static/media/douglas-app-icon.24222ef95abd34c046db97eab6eeaeeb.svg";
export { ForwardRef as ReactComponent };